import React, { Component } from 'react';

import Aux from '../hoc/Auxiliary';
import DropInfoDisplay from '../DropInfoDisplay/DropInfoDisplay';
import TrdHowItWorks from '../../components/UI/HowItWorks/TrdHowItWorks/TrdHowItWorks';
import Input from '../../components/UI/Input/Input';
import Button from '../../components/UI/Buttons/Button/Button';
import Spinner from '../../components/UI/Spinner/Spinner';
import TrdFallBack from '../../components/UI/TrdAdminFocus/TrdFallBack/TrdFallBack'
import Modal from '../../components/UI/Modal/Modal';
import ImageModal from '../../components/UI/Modal/ImageModal/ImageModal';
import BackButton from '../../components/UI/Buttons/BackIconButton/BackIconButton';
import ModalImageViewer from '../../components/UI/Modal/ModalImageViewer/ModalImageViewer';
import withErrorHandler from '../hoc/withErrorHandler/withErrorHandler';

import ModalMessage from '../../components/UI/TrdModalScreen/ModalMessage/ModalMessage';

import axios from '../../axios-drops';

import classes from './DibsItForm.css';

class DibsItForm extends Component {

    state = {
        inputForm: {
            name: {
                elementType: 'input', 
                elementConfig: {
                    type: 'text',
                    placeholder: 'Your Name'
                },
                value: '',
                validation: {
                    required: true
                },
                valid: false,
                touched: false,
                name: 'Facebook Name*'
            },
            email: {
                elementType: 'input', 
                elementConfig: {
                    type: 'text',
                    placeholder: 'Your Email'
                },
                value: '',
                validation: {
                    required: true,
                    isEmail: true
                },
                valid: false,
                touched: false,
                name: 'PayPal Email Address*'
            },
            secondaryEmail: {
                elementType: 'input', 
                elementConfig: {
                    type: 'text',
                    placeholder: 'Your Email (optional)'
                },
                value: '',
                validation: {
                    required: false
                },
                valid: true,
                touched: false,
                name: 'Join Email Drop List (optional)'
            }
        },
        drop: null,
        showSideDrawer: false,
        formIsValid: false,
        dropIsLive: false,
        checkedServer: false,
        selectedDropMenuId: null,
        repeatEntry: false,
        success: false,
        imageClicked: false,
        userIp: null
    }

    componentDidMount () {
        window.scrollTo(0, 0);

        let userIp = null

        const func = async () => {

         
            // console.log(userIp)
            await axios.get('https://api64.ipify.org?format=jsonp?callback=?')
                .then(response => {
                    userIp = response.data

                    // if (response.data === undefined) {
                    //     userIp = this.getRandomString()
                    // } else {
                    //     userIp = response.data
                    // }
                })

                // if (userIp === null || userIp === '' || userIp === undefined){
                //     userIp = this.getRandomString()
                // }


                // console.log(userIp)

            await axios.get('/registrations/' + this.props.match.params.id + '/general.json')
                .then(response => {
                    for (let key in response.data) {
                        
                        // if (response.data[key].ip === '174.215.200.153'){
                        //     console.log(response.data[key])
                        //     console.log(key)
                        // }

                        if(response.data[key].ip !== undefined){
                            // console.log(response.data[key].ip)
                            if ( userIp === response.data[key].ip){
                                this.setState({repeatEntry: true})
                            }
                        }
                    }
                })



            await axios.get('/drops/' + this.props.match.params.id + '.json')
                .then(response => {
                let serverChecked = true;
                let liveDrop = true;
                const fetchedDrop = response.data    
    
                if (response.data === null) {
                    this.props.history.push('/')
                }
            
            this.setState({
                drop: fetchedDrop,
                dropIsLive: liveDrop,
                userIp: userIp,
                checkedServer: serverChecked})
            })
        }
        func() 
    }

    getRandomInt = () => {
        return Math.floor(Math.random() * Math.floor(8)) + 1
    }

    getRandomString = () => {
        let result = '';
        for (let i = 0; i < 10; ++i) {
            result += this.getRandomInt();
        }
        
        for(let i = 0; i < this.getRandomInt(); ++i) {
            if ( this.getRandomInt() >= 3 ) {   // random mutations
                result += this.getRandomInt();
            } 
        }
        return result;
    }
    

    howItWorksDrawerOpenHandler = () => {
        this.setState({ showSideDrawer: true})  
    }

    howItWorksDrawerClosedHandler = () => {
        this.setState({ showSideDrawer: false})
    }

    checkValidity(value, rules) {
         let isValid = true;

         if (!rules) {
             return true
         }

         if (rules.required) {
            isValid = value.trim() !== '' && isValid;
         }

         if (rules.minLength) {
             isValid = value.length >= rules.minLength && isValid
         }

         if ( rules.maxLength ) {
            isValid = value.length <= rules.maxLength && isValid
        }

        if ( rules.isEmail ) {
            const pattern = /[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?/;
            isValid = pattern.test( value ) && isValid
        }

        if ( rules.isNumeric ) {
            const pattern = /^\d+$/;
            isValid = pattern.test( value ) && isValid
        }

         return isValid;
    }

    inputChangedHandler = (event, inputIdentifier) => {
        const updatedInputForm = {
            ...this.state.inputForm
        }

        const updatedFormElement = {
            ...updatedInputForm[inputIdentifier]
        }

        updatedFormElement.value = event.target.value;

        updatedFormElement.valid = this.checkValidity(
            updatedFormElement.value, updatedFormElement.validation
        )
        updatedFormElement.touched = true;

        updatedInputForm[inputIdentifier] = updatedFormElement;

        let formIsValid = true;
        for (let inputIdentifier in updatedInputForm) {
            formIsValid = updatedInputForm[inputIdentifier].valid && formIsValid;
        }

        this.setState({ inputForm: updatedInputForm,
                        formIsValid: formIsValid});
    }


    clearFormValues = () => {
        const updatedInputForm = {
            ...this.state.inputForm
        }

        const updatedFormName = {
            ...updatedInputForm.name
        }
        const updatedFormEmail = {
            ...updatedInputForm.email
        }
        const updatedFormOtherEmail = {
            ...updatedInputForm.secondaryEmail
        }
 
        updatedFormName.value = '';

        updatedFormName.valid = false;
        updatedFormName.touched = false;

        updatedInputForm.name = updatedFormName;
        
        updatedFormEmail.value = '';
        updatedFormEmail.valid = false;
        updatedFormEmail.touched = false;

        updatedInputForm.email = updatedFormEmail;

        updatedFormOtherEmail.value = '';

        updatedInputForm.secondaryEmail = updatedFormOtherEmail;
        
        this.setState({inputForm: updatedInputForm,
                        formIsValid: false})

    }

    postRegistration = async (registration) => {

        await axios.post('/registrations/' + this.props.match.params.id + '/general.json', registration)
                    .then(response => {

                    if (response.status === 200) {
                        
                        this.setState({success: true})
                        this.disableScroll()
                        this.clearFormValues()
                    }
                
            })
            
    }

    alreadyRegisteredCheck = () => {
        return true
    }

    saveClickedHandler = async () => {

       

        if (this.state.inputForm.secondaryEmail.value.length > 0) {

            if (this.alreadyRegisteredCheck()){
                const other = this.state.inputForm.secondaryEmail.value
                const subscribe = {
                    email: other,
                    ip: this.state.userIp
                }
                await axios.post('/email-list.json', subscribe)
                .then(response => {
                    // this.clearFormValues()
                    // show thanks for subscribing modal
                    // this.setState({subscribed: true})
                    // get out of email modal 
                }).catch(error => console.log(error));
            }
          
    
        }

      
        const registration = {
            name: this.state.inputForm.name.value,
            paypal: this.state.inputForm.email.value,
            // other: other,
            ip: this.state.userIp
        }

        let firstEntry = true
        
       

        await axios.get('/registrations/' + this.props.match.params.id + '/general.json')
            .then(response => {
                for (let key in response.data) {
                    // console.log(response.data[key].name.toLowerCase())
                    
                    if (response.data[key].paypal.toLowerCase() === this.state.inputForm.email.value.toLowerCase()) {
                            firstEntry = false;
                            break;
                    }
                }
                if (firstEntry) {
                    this.postRegistration(registration)
                } else {
                    this.clearFormValues();
                    this.setState({repeatEntry: true})
                }
            })
    }

    closeModalHandler = () => {
        this.setState({repeatEntry: false,
                    success: false})
        this.enableScroll()
        this.backButtonClickedHandler()
    }

    backButtonClickedHandler = () => {
        this.props.history.goBack()
    }

    imageClickedHandler = () => {
        this.setState({imageClicked: true})
        this.disableScroll()

    }
    closeImageHandler = () => {
        this.setState({imageClicked: false})
        this.enableScroll()
    }

    disableScroll = () => {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop
        const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft

        window.onscroll = () => {
            window.scrollTo(scrollLeft, scrollTop)
        }
    }

    enableScroll = () => {
        window.onscroll = () => {}
    }


    render() {

        let currentDrops = null;

        if (this.state.drop !== null ) {

            currentDrops = (<div>
                <DropInfoDisplay 
                    clicked={this.imageClickedHandler}
                    key={this.state.drop.id}
                    image={this.state.drop.image}
                    name={this.state.drop.name}
                    variant={this.state.drop.variant}
                    edition={this.state.drop.edition}
                    cost={this.state.drop.cost}
                    numberAvailable={this.state.drop.availability} />
            </div>)
        }

        const formElementsArray = [];
        for (let key in this.state.inputForm) {
            formElementsArray.push({
                id: key,
                config: this.state.inputForm[key]
            })
        }

        let form = (
            <form onSubmit={this.submitFormHandler}>
                {formElementsArray.map(formElement => (
                    <Input key={formElement.id}
                        elementType={formElement.config.elementType}
                        elementConfig={formElement.config.elementConfig}
                        value={formElement.config.value}
                        invalid={!formElement.config.valid}
                        shouldValidate={formElement.config.validation}
                        touched={formElement.config.touched}
                        changed={(event) => this.inputChangedHandler(event, formElement.id)}
                        name={formElement.config.name}/>
                ))}
            </form>
        )


        let dibsItPage = <div className={classes.Spinner}><Spinner /></div>

        if (this.state.dropIsLive && this.state.checkedServer && this.state.drop !== null) {
            dibsItPage = (
                <Aux>
                    <ImageModal show={this.state.imageClicked} modalClosed={this.closeImageHandler}>
                        <ModalImageViewer image={this.state.drop.image}/>
                    </ImageModal>
                    {currentDrops}
                    <div className={classes.InfoSection}>
                        <p>(*) Required Field</p>
                        <div className={classes.HowItWorksLink}
                            onClick={this.howItWorksDrawerOpenHandler}>
                            <p>How It Works?</p>
                        </div>                  
                    </div>
                    <TrdHowItWorks
                            open={this.state.showSideDrawer}
                            closed={this.howItWorksDrawerClosedHandler}/>
                    <div className={classes.FormSection}>
                    </div>
                    <div className={classes.SubmitSection}>
                        {form}
                        <Button btnType="Submit" disabled={!this.state.formIsValid}
                            clicked={this.saveClickedHandler}>
                            SUBMIT
                        </Button>
                    </div>
                    <BackButton clicked={this.backButtonClickedHandler} />
                </Aux>
            )
        } else if (!this.state.dropIsLive && this.state.checkedServer ) {
            dibsItPage = <TrdFallBack />
        }

        let modalView = <div><p><strong>404: An Error Occured</strong></p></div>;

        if (this.state.repeatEntry) {
            modalView = 
                <div>
                    <ModalMessage message={"You've Already Registered..."} />
                </div>
        }
        else if (this.state.success) {
            modalView =
                <div>
                    <ModalMessage message={"You've Successfully Registered!"}/>
                </div>
        }



        return (
            <div>
                
                <Modal show={this.state.repeatEntry || this.state.success} modalClosed={this.closeModalHandler}>
                    {modalView}
                </Modal>
                {dibsItPage}
            </div>
        )
    }
}

export default withErrorHandler(DibsItForm, axios);


// WEBPACK FOOTER //
// ./src/containers/DibsItForm/DibsItForm.js